import React from "react";
import { listRides, listRidesParc } from "../../actions/rides";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faPlus } from "@fortawesome/free-solid-svg-icons";
import { getIdInUrl, tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import AdminItemRide from "../../components/AdminItemRide";
import Alert from "../../components/Alert";

class AdminParcRide extends React.Component {
    state = {
        menuActive: false,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        opts: [{
            type: 'link',
            ttl: 'Retourner à la liste des parcs',
            ico: faArrowLeft,
            link: '/admin/parcs',
            action: null,
            col: null
        }],
        datas: {
            parcName: '',
            rides: []
        }
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.listRidesParc({parcId: getIdInUrl()});
            this.setState({
                alert: tempAlWait()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.listRidesParc({parcId: getIdInUrl()});
                this.setState({
                    alert: tempAlWait()
                });
            }
        }

        if (prevProps.redRidesParc != this.props.redRidesParc) {
            this.setState({
                alert: this.props.redRidesParc.alert,
                datas: this.props.redRidesParc.datas
            })
        }
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl={`Les attractions de ${this.state.datas.parcName}`}
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.rides.length == 0 ?
                        <h2 className="admin__empty">Aucune attraction n'a été ajoutée pour le moment.</h2> :
                        <ul className="admin__list">
                            {
                                this.state.datas.rides.map((data, key) => {
                                    return <AdminItemRide
                                        data={data}
                                        key={`ride-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.listRides();
                                            }
                                        }}
                                    />
                                })
                            }
                        </ul>
                }
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redRidesParc: state.redRidesParc
    }
}

const mapDispatchToProps = {
    listRidesParc
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminParcRide);